const SITE_URL_REGEX = /^https?:\/\/[^/]+/

export default function getIssueUrl(key, apiUrl) {
  const [siteUrl] = apiUrl.match(SITE_URL_REGEX)
  return `${siteUrl}/browse/${key}`
}
